import api from "./api";

const doctorService = {};
const endpoint = "/doctors";

doctorService.getDoctors = function () {
  return api.get(endpoint).then((res) => res.data);
};

doctorService.getDoctorDetails = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

/**
 * @description Subida masiva de prestadores desde un Excel (.xlsx).
 *              El API parsea el archivo, resuelve especialidades + instituciones
 *              por nombre, valida campos requeridos, y crea cada prestador con
 *              email de invitación para set-password. Idempotente: si el
 *              prestador ya existe (mismo DNI/email/matrícula) lo cuenta como
 *              "duplicado" sin pisarlo.
 * @param {File} file - Archivo .xlsx (HTML File object desde input[type=file])
 * @returns {Promise<{total: number, imported: number, duplicates: number, errors: Array<{row: number, error: string}>}>}
 */
doctorService.bulkImport = function (file) {
  const formData = new FormData();
  formData.append("file", file);
  return api
    .post(`${endpoint}/import`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

export default doctorService;
